import React from "react";
import { BankData } from "../../../types";
import { BankAccountForm } from "./BankAccountForm";
import ErrorComponent from "../../Error";
import { useCompanyStore } from "../../../state/useCompanyStore";
import { useGetPaymentCurrencyList } from "../../../utils";

interface CreateProps {
  onCreate: (data: BankData) => void;
  showButton: boolean;
  isLoading: boolean;
  onClose?: () => void;
}

const CreateBankAccount: React.FC<CreateProps> = ({
  onCreate,
  onClose,
  isLoading,
}) => {
  const companyProfile = useCompanyStore();
  const { userCurrencyCode } = useGetPaymentCurrencyList(
    companyProfile.company,
  );
  const handleCreate = async (data: BankData) => {
    try {
      onCreate(data);
    } catch (error) {
      return <ErrorComponent errorCode={500} />;
    } finally {
    }
  };

  return (
    <>
      <BankAccountForm
        initialData={{
          bankName: "",
          accountNumber: "",
          accountName: "",
          isActive: true,
          currency: userCurrencyCode.currency,
        }}
        title="Add Bank Account"
        onSubmit={handleCreate}
        onClose={onClose}
        isLoading={isLoading}
      />
    </>
  );
};

export default CreateBankAccount;
